<script lang="ts">
    import { melt, createDatePicker } from '@melt-ui/svelte';
    import { type AnyMeltElement } from '@melt-ui/svelte';
    import './Calendar.css';

    export let calendar: AnyMeltElement;
    export let cell: ReturnType<typeof createDatePicker>['elements']['cell'];
    export let grid: AnyMeltElement;
    export let heading: AnyMeltElement;
    export let nextButton: AnyMeltElement;
    export let prevButton: AnyMeltElement;
    export let onCellClick: () => void = () => {};

    export let months: ReturnType<typeof createDatePicker>['states']['months'];
    export let headingValue: ReturnType<
        typeof createDatePicker
    >['states']['headingValue'];
    export let weekdays: ReturnType<typeof createDatePicker>['states']['weekdays'];
    export let isDateDisabled: ReturnType<
        typeof createDatePicker
    >['helpers']['isDateDisabled'];
    export let isDateUnavailable: ReturnType<
        typeof createDatePicker
    >['helpers']['isDateUnavailable'];
</script>

<div use:melt={$calendar} class="melt-calendar">
    <header>
        <button use:melt={$prevButton}>
            <i class="tnp tnp-chevron-left" aria-hidden={true} />
        </button>
        <div use:melt={$heading}>
            {$headingValue}
        </div>
        <button use:melt={$nextButton}>
            <i class="tnp tnp-chevron-right" aria-hidden={true} />
        </button>
    </header>
    <div>
        {#each $months as month}
            <table use:melt={$grid}>
                <thead aria-hidden="true">
                    <tr>
                        {#each $weekdays as day}
                            <th>
                                <div>
                                    {day}
                                </div>
                            </th>
                        {/each}
                    </tr>
                </thead>
                <tbody>
                    {#each month.weeks as weekDates}
                        <tr>
                            {#each weekDates as date}
                                <td
                                    role="gridcell"
                                    aria-disabled={$isDateDisabled(date) ||
                                        $isDateUnavailable(date)}
                                >
                                    <div
                                        use:melt={$cell(date, month.value)}
                                        on:m-click={(_e) => {
                                            onCellClick();
                                        }}
                                    >
                                        {date.day}
                                    </div>
                                </td>
                            {/each}
                        </tr>
                    {/each}
                </tbody>
            </table>
        {/each}
    </div>
</div>
